'use strict'

import ApiClient from './ApiClient'

export default class BcardImageRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 画像からの登録状況一覧情報のうち、登録待ちとなっているものを取得します。
   * @param {object} params 検索条件
   * @returns {*}
   */
  getQueues (params) {
    return ApiClient().get(`/bcard-images/queues`, { params })
  }

  /**
   * 画像からの登録状況一覧情報のうち、読取不能となっているものを取得します。
   * @param {object} params 検索条件
   * @returns {*}
   */
  getErrors (params) {
    return ApiClient().get(`/bcard-images/errors`, { params })
  }

  /**
   * 指定された複数名刺IDの画像からの登録状況情報（エラーになったもののみ）を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/bcard-images/errors/delete`, data)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/BcardImageRepository.js